import {
  faLockKeyhole,
  faLockKeyholeOpen,
} from '@fortawesome/pro-regular-svg-icons';
import { useTheme } from '@mui/material';
import CoverageButton from '../components/coverages/amendatory-coverages/shared/CoverageButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import SimpleTooltip from '../../../../../../../components/SimpleTooltip';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

type PegValueModuleProps = {
  isPegValue: boolean;
  onUpdatePegValue: (isPegValue: boolean) => void;
};

const PegValueModule = ({
  isPegValue,
  onUpdatePegValue,
}: PegValueModuleProps) => {
  const isOn = useFeatureIsOn('RATER_PEG_VALUE');

  const theme = useTheme();

  let linkProps = {
    icon: faLockKeyholeOpen,
    tooltip: 'The value will be recalculated when global values change.',
  };

  if (isPegValue) {
    linkProps = {
      icon: faLockKeyhole,
      tooltip:
        'The value will be retained on recalculation, unless it is invalid.',
    };
  }

  if (!isOn) {
    return null;
  }

  return (
    <SimpleTooltip
      title={linkProps.tooltip}
      enterDelay={500}
      enterNextDelay={500}
      style={{ marginLeft: 0, display: 'inline' }}
      arrow
    >
      <CoverageButton
        style={{
          width: '1rem',
          minWidth: '1rem',
          marginBottom: '0.2rem',
          marginLeft: '-0.25rem',
          border: 'none',
          color: isPegValue
            ? theme.config.colors.cowbellBlue
            : theme.palette.text.contrastText,
        }}
        onClick={() => {
          onUpdatePegValue(!isPegValue);
        }}
      >
        <FontAwesomeIcon
          style={{ fontSize: '1.15rem' }}
          icon={linkProps.icon as IconProp}
        />
      </CoverageButton>
    </SimpleTooltip>
  );
};

export default PegValueModule;
